"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Portal = _interopRequireDefault(require("../../Portal"));
var _bodyScrollLock = require("body-scroll-lock");
var _usePrevious = _interopRequireDefault(require("../../../hooks/usePrevious"));
var _cls = _interopRequireDefault(require("@soluto-design/styles/cls"));
var _modal = _interopRequireDefault(require("@soluto-design/styles/components/atoms/modal"));
var _excluded = ["classes", "className", "disableBackgroundClose", "disableEscapeClose", "variant", "onToggle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Modal = /*#__PURE__*/(0, _react.forwardRef)(function Modal(_ref, ref) {
  var classes = _ref.classes,
    className = _ref.className,
    disableBackgroundClose = _ref.disableBackgroundClose,
    disableEscapeClose = _ref.disableEscapeClose,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    onToggle = _ref.onToggle,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    preShow = _useState4[0],
    setPreShow = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    show = _useState6[0],
    setShow = _useState6[1];
  var allowClose = (0, _react.useRef)(true);
  var modalsOpen = (0, _react.useRef)(0);
  var modalRef = (0, _react.useRef)(null);
  var contentRef = (0, _react.useRef)(null);
  var prevShow = (0, _usePrevious["default"])(show);
  var prevPreShow = (0, _usePrevious["default"])(preShow);
  (0, _react.useEffect)(function () {
    return setIsMounted(true);
  }, []);
  var open = (0, _react.useCallback)(function () {
    setPreShow(true);
    setTimeout(function () {
      setShow(true);
    }, 250);
  }, []);
  var close = (0, _react.useCallback)(function () {
    if (!allowClose.current) {
      allowClose.current = true;
      return;
    }
    setShow(false);
    setTimeout(function () {
      setPreShow(false);
    }, 250);
  }, []);
  var toggle = (0, _react.useCallback)(function () {
    if (!show) {
      open();
    } else {
      close();
    }
  }, [show, open, close]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      toggle: toggle,
      open: open,
      close: close,
      show: show,
      preShow: preShow
    };
  }, [preShow, show, toggle, open, close]);
  (0, _react.useEffect)(function () {
    if (show && !prevShow) {
      modalsOpen.current += 1;
      if (modalRef !== null && modalRef !== void 0 && modalRef.current) {
        (0, _bodyScrollLock.disableBodyScroll)(contentRef.current);
        modalRef.current.focus();
      }
      if (onToggle) {
        onToggle(show);
      }
    } else if (!show && prevShow) {
      modalsOpen.current -= 1;
      allowClose.current = true;
      if (modalRef !== null && modalRef !== void 0 && modalRef.current) {
        (0, _bodyScrollLock.enableBodyScroll)(contentRef.current);
      }
      if (!modalsOpen.current) {
        (0, _bodyScrollLock.clearAllBodyScrollLocks)();
      }
      if (onToggle) {
        onToggle(show);
      }
    }
  }, [show, preShow, prevShow, prevPreShow, onToggle]);
  (0, _react.useEffect)(function () {
    if (typeof window === 'undefined' || disableEscapeClose || !show) {
      return;
    }
    var onKeyDown = function onKeyDown(e) {
      if (e.key === 'Escape') {
        close();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return function () {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [disableEscapeClose, show, close]);
  (0, _react.useEffect)(function () {
    if (modalRef !== null && modalRef !== void 0 && modalRef.current) {
      if (prevShow && !show) {
        (0, _bodyScrollLock.enableBodyScroll)(modalRef.current);
      }
    }
  }, [show, modalRef, prevShow]);
  var closeFromBackground = (0, _react.useCallback)(function () {
    if (disableBackgroundClose) {
      return;
    }
    close();
  }, [disableBackgroundClose, close]);
  var unallowClose = (0, _react.useCallback)(function () {
    if (disableBackgroundClose) {
      return;
    }
    allowClose.current = false;
  }, [disableBackgroundClose]);
  return isMounted && /*#__PURE__*/_react["default"].createElement(_Portal["default"], {
    id: "modal"
  }, preShow ? /*#__PURE__*/_react["default"].createElement("div", {
    id: "modal-backdrop",
    className: (0, _cls["default"])(_modal["default"].backdrop, _modal["default"]["backdrop-".concat(variant)], classes === null || classes === void 0 ? void 0 : classes.backdrop, show && _modal["default"].show)
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: modalRef,
    className: (0, _cls["default"])(_modal["default"].modal, _modal["default"]["modal-".concat(variant)], classes === null || classes === void 0 ? void 0 : classes.wrapper, className, show && _modal["default"].show, show && (classes === null || classes === void 0 ? void 0 : classes.show)),
    style: preShow ? {
      display: 'block'
    } : {},
    tabIndex: -1,
    hidden: !show,
    onClick: closeFromBackground,
    "aria-modal": "true",
    role: "dialog"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: unallowClose,
    className: (0, _cls["default"])(_modal["default"].dialog, classes === null || classes === void 0 ? void 0 : classes.dialog),
    role: "document"
  }, /*#__PURE__*/_react["default"].createElement("div", _extends({
    ref: contentRef,
    className: (0, _cls["default"])(_modal["default"].content, className, classes === null || classes === void 0 ? void 0 : classes.content)
  }, props)))));
});
var _default = exports["default"] = Modal;
module.exports = exports.default;